module.exports = __webpack_public_path__ + "8afe4dc13b83b66fec0ea671419954cc.ttf";